module.exports = __webpack_public_path__ + "img/ep8-2.eaefeeac.png";